export default function getResource(label, vars = []) {
    const resources = {
        title: 'Create Account',
        inStoreMemberTitle: 'Check Your Email',
        backButtonAriaLabel: 'Go back',
        joinBiFreeShip: 'Join the Beauty Insider loyalty program. Earn points, get *FREE standard shipping*, redeem rewards, and more.',
        emailAddresLabel: 'Email Address',
        firstNameLabel: 'First Name',
        lastNameLabel: 'Last Name',
        passwordLabel: `Password (${vars[0]} to ${vars[1]} characters)`,
        phoneNumber: 'Phone Number',
        phoneNumberBenefit: 'Enter your phone number for easy look up in stores.',
        marketingCheckbox: 'Sign me up for Sephora marketing text alerts.',
        zipCodeLabel: 'ZIP/Postal Code (optional)',
        staySignedInLabel: 'Keep me signed in',
        and: ' and ',
        biTerms: 'BEAUTY INSIDER TERMS',
        privacyPolicy: 'Privacy Policy',
        receiveOffers: ', and to automatically receive Beauty Insider offers and notifications via email.',
        noticeFinancialIncentive: 'Notice of Financial Incentive',
        byClicking: 'By clicking "Join Now" you acknowledge that you are a U.S. or Canada resident and (1) have read Sephora’s',
        disclosure: 'Sephora Text Alerts Disclosure:',
        byEntering: ' By entering your phone number, checking the',
        signMeUp: ' Sign me up for Sephora marketing text alerts checkbox,',
        clicking: ' clicking the "Join Now" button and confirming sign-up, you consent and agree to receive recurring autodialed marketing texts, including abandoned cart reminders, and confirm that you have read and agree to the',
        textTerm: ' TEXT TERMS.',
        agreeTo: ' agree to ',
        termsOfUse: 'TERMS OF USE',
        message: ' Message frequency varies. Consent is not a condition of purchase. Message & data rates may apply. See our ',
        privacy: 'PRIVACY POLICY',
        noticeOf: 'NOTICE OF FINANCIAL INCENTIVE',
        textStop: ' Text STOP to cancel at any time. HELP for help.',
        textStopAddress: ' Sephora: 600 de Maisonneuve Boulevard West, Suite 2400, Montréal, Québec, H3A 3J2, Canada. 1-877-737-4672.',
        joinNow: 'Join Now',
        alreadyHaveAccount: 'Already have an account?',
        signIn: 'Sign In',
        genericErrorMessage: 'An error occurred. Please try again.',
        notYouMessage: 'Not you?',
        signInHere: 'Sign in here',
        confirmButton: 'Continue',
        invalidEmailError: 'Invalid email address type. Please use a valid email address',
        staySignedInTooltip: 'Selecting this option means you won’t have to sign in as often on this device. For your security, we recommend only doing this on your personal devices.',
        sentVerificationLink: 'We sent a verification link to',
        gotIt: 'Got it',
        step1: 'Click the link in your email to verify',
        step2: 'Complete account setup',
        step3: 'Return here and sign in to continue',
        nextStep: 'Next Step',
        emailMissed: 'Didn’t get it? Check your spam folders or ',
        resend: 'send again.',
        errorResend: 'Something went wrong, and we could not resend the email. Please try again later or resend the email.',
        successResend: 'Email successfully resent.',
        errorModalTitle: 'Error',
        successModalTitle: 'Success',
        okButton: 'OK',
        resendButton: 'Resend',
        congratulation1: 'Congratulations!',
        congratulation2: 'You are now a Beauty Insider!'

    };

    return resources[label];
}
